import { camelCase } from '@ridi/object-case-converter';
import { extendObservable } from 'mobx';
import AbstractRoot from '../../common_components/stores/AbstractRoot';
import FeedbackChainsStore from './FeedbackChains';
import FeedbackParticipantsStore from './FeedbackParticipants';
import FeedbackCommentsStore from './FeedbackComments';
import AttachmentsStore from '../../common_components/attachments/stores/Attachments';
import GooglePicker from '../../../libs/google_picker';
import BoxPicker from '../../../libs/box_picker';
import AuthorizationsStore from './Authorizations';
import ValuePropositionsStore from './ValuePropositions';
import TasksStore from './TasksStore';
import AnalyticsStore from './Analytics';


export default class Root extends AbstractRoot {
  constructor(currentUser, roles, localeStore, team, currentStartup, startup) {
    super(camelCase(currentUser), roles, localeStore);

    this.feedbackParticipantsStore = new FeedbackParticipantsStore(this);
    this.feedbackCommentsStore = new FeedbackCommentsStore(this);
    this.feedbackChainsStore = new FeedbackChainsStore(this);
    this.attachmentsStore = new AttachmentsStore(this);
    this.authorizationsStore = new AuthorizationsStore(this);
    this.valuePropositionsStore = new ValuePropositionsStore(this);
    this.tasksStore = new TasksStore(this);
    this.analyticsStore = new AnalyticsStore(this);

    this.googlePicker = new GooglePicker();
    this.boxPicker = new BoxPicker();

    this.startupTeam = camelCase(team, true);
    this.startup = camelCase(startup);
    this.startupId = this.startup.id;
    this.currentStartup = camelCase(currentStartup) || {};

    this.loadData();
  }

  loadData() {
    this.feedbackChainsStore.fetchData();
    this.valuePropositionsStore.fetchData();
  }

  currentUserBelongsToStartup() {
    return this.startupTeam.map((m) => m.user.id).includes(this.user.id);
  }
}
